import { InitialStateType } from 'initialState'

export const getPriceData = (state: InitialStateType) => state.price
